/* eslint-disable no-useless-computed-key */
/* eslint-disable no-unused-vars */
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Logo from '../static/images/ALFRED_BLACK_SVG.svg';
import LogoWs from '../static/images/LoginIMG.png';
import { authApi, requestHttp } from '../api/services-third-parties';
import { useDispatch } from 'react-redux';
import { actionSetAuth } from '../actions/businessAction';
import { RegExpValidator } from '../core/regExp-generic';
import { ErrorsIcon } from '../components/Icons/errorIcon';
import OtpInput from 'react-otp-input';
import { BusinessController } from '../core/controller/BusinessCtrl';

export const Login = () => {
    const businessController = new BusinessController()
    const [state, setState] = useState({
        email: '',
        password: '',
        twoAuthFactor: false,
        resetPassword: false,
        code: '',
        error: false
    });

    const [actinValid, setactinValid] = useState('login');
    const [errors, setErrors] = useState({});
    const [isFormValid, setIsFormValid] = useState(false);
    const [otp, setOtp] = useState('');
    const [titleForm, settitleForm] = useState({
        login: {
            title: 'Welcome 👋',
            subTitle: ' Please enter your details'
        },
        changePass: {
            title: '',
            subTitle: 'You change your password, login using your new password'
        }
    });
    const dispatch = useDispatch();
    const navigate = useNavigate();


    const handleChangeEmail = event => {
        event.preventDefault();
        const { name, value } = event.target;
        if (!RegExpValidator.email.test(value)) {
            setErrors((prevErrors) => ({ ...prevErrors, [name]: true }));
            setIsFormValid(false);
        } else {
            setErrors((prevErrors) => ({ ...prevErrors, [name]: false }));
            setIsFormValid(Object.values(errors).every((error) => !error));
        }

        setState((prevProps) => ({
            ...prevProps,
            [name]: value
        }))
    }

    const handleChange = event => {
        const { name, value } = event.target;
        setState((prevProps) => ({
            ...prevProps,
            [name]: value
        }))

        if (value.length < 4) {
            setIsFormValid(false);
        } else {
            setIsFormValid(true);
        }
    }

    const handleSubmit = async (event) => {
        try {
            event.preventDefault();
            if (!RegExpValidator.email.test(state.email)) {
                setErrors((prevErrors) => ({ ...prevErrors, ['email']: true }));
                setIsFormValid(false);
            } else {
                setErrors((prevErrors) => ({ ...prevErrors, ['email']: false }));
                setIsFormValid(true);
            }

            setState((prevProps) => ({
                ...prevProps,
                error: false
            }));
            let dataReq = {
                'email': state.email,
                'password': state.password,
            }

            if (state.twoAuthFactor) dataReq['code'] = otp

            const response = await businessController.businessLogin(dataReq)

            if ([202].includes(response.data.statusCode)) {

                if ('Error'.includes(response.data.data.name)) {
                    setOtp('')
                    setState((prevProps) => ({
                        ...prevProps,
                        error: true
                    }))

                    return
                }

                localStorage.setItem('token', response.data.data['access_token']);
                if (response.data.data['twoAuthFactor']) {
                    setState((prevProps) => ({
                        ...prevProps,
                        twoAuthFactor: response.data.data['twoAuthFactor'],
                        error: false
                    }))

                    return
                }

                if (response.data.data['user']['resetPassword']) {
                    navigate('/change-password');
                    localStorage.setItem('email', state.email)
                    setState((prevProps) => ({
                        ...prevProps,
                        resetPassword: response.data.data['user']['resetPassword'],
                        error: false
                    }))

                    return

                }

                dispatch(actionSetAuth({
                    id: response.data.data['user']['business']['id'],
                    name: response.data.data['user']['business']['name'],
                    email: response.data.data['user']['email'],
                    country: response.data.data['user']['business']['country'],
                    typeBusiness: response.data.data['user']['business']['typeBusiness'],
                    apiKey: response.data.data['user']['business']['apiKey'],
                    apiSecret: response.data.data['user']['business']['apiSecret'],
                    role: response.data.data['user']['role']
                }));



                navigate('/dashboard');
                return
            } else {
                setOtp('')
                setState((prevProps) => ({
                    ...prevProps,
                    error: true
                }))
            }
        }
        catch (error) {

        }
    }

    const handleSubmitVerifi = (e) => {
        e.preventDefault();
        navigate('/forgot-password');
    }

    const handleRedirectToWebsite = () => {
        window.location.href = 'https://www.alfredpay.io/get-started';
    };

    const handleRedirectToWebsite2 = () => {
        window.location.href = 'https://www.alfredpay.io/'
    }

    useEffect(() => {
        localStorage.removeItem('token')
        localStorage.removeItem('email')
        sessionStorage.removeItem('time')
    }, [])

    return (
        <>
            <div className="flex h-screen w-screen">
                <div className='flex flex-col items-center justify-center w-full gap-10'>
                    <div className='login-section-img w-1/2 pl-[70px] cursor-pointer' onClick={handleRedirectToWebsite2}>
                        <img src={Logo} alt="alfredpay logo" className='logo-login' />
                    </div>
                    <div className='w-[80%]'>
                        <p className='login-welcome mb-[20px]'>{titleForm[actinValid].title}</p>
                        <p className='login-welcome-sub'>{titleForm[actinValid].subTitle}</p>
                        {
                            state.resetPassword && (
                                <p className='login-welcome-sub login-changePass mt-[40px]'>{titleForm['changePass'].subTitle}</p>
                            )
                        }
                    </div>

                    <form action="" className='flex flex-col gap-4 items-center w-[70%]' autoComplete="off" onSubmit={handleSubmit}>
                        {state.error &&
                            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative w-full text-center" role="alert">
                                <span className="block sm:inline">User or password incorrect.</span>
                            </div>
                        }
                        {
                            !state.twoAuthFactor && (
                                <>
                                    <div className="flex flex-col w-full gap-4">
                                        <label htmlFor="" className='login-Label'>Email</label>
                                        <input
                                            type="email"
                                            name="email"
                                            required
                                            className={`login-input w-full h-10 p-[10px] ${errors.email ? 'errors-input' : ''}`}
                                            onChange={(e) => handleChangeEmail(e)}
                                            value={state.email} />
                                        {errors.email && (
                                            <div className='flex errors-msm'>
                                                <ErrorsIcon className='mr-2 w-[1.5rem]' /> email not registered, please try again
                                            </div>
                                        )}
                                    </div>
                                    <div className="flex flex-col w-full gap-4">
                                        <div className='flex justify-between'>
                                            <label htmlFor="" className='login-Label'>Password</label>
                                        </div>
                                        <input
                                            type="password"
                                            name="password"
                                            required
                                            className={`login-input w-full h-10 p-[10px] ${errors.password ? 'errors-input' : ''}`}
                                            onChange={handleChange}
                                            value={state.password} />
                                        <div className='flex justify-between'>
                                            <label htmlFor="" className='login-Label'></label>
                                            <label htmlFor="" className='color-Logout login-laabel-pass' onClick={(e) => handleSubmitVerifi(e)}>Forgot your password?</label>
                                        </div>
                                        {errors.password && (
                                            <div className='flex errors-msm'>
                                                <ErrorsIcon className='mr-2 w-[1.5rem]' /> Wrong password, please try again
                                            </div>
                                        )}
                                    </div>
                                </>
                            )
                        }

                        {
                            state.twoAuthFactor && (
                                <div className="flex flex-col w-full gap-4">
                                    <div className='flex justify-center'>
                                        <label htmlFor="" className='login-Label'>Enter authentication code</label>
                                    </div>
                                    <OtpInput
                                        value={otp}
                                        onChange={setOtp}
                                        numInputs={6}
                                        renderSeparator={<span> </span>}
                                        inputType='tel'
                                        renderInput={(props) => <input {...props} />}
                                        containerStyle={`w-full justify-center`}
                                        inputStyle='input-otp'
                                    />
                                </div>
                            )
                        }


                        <button
                            type="submit"
                            disabled={!isFormValid}
                            className={`${isFormValid ? 'btn-active' : 'btn-disabled'}  text-white text-center w-full p-[0.7rem] border rounded-full login-btn-text`}
                        >
                            {state.twoAuthFactor ? 'Log in' : 'Log in'}
                        </button>
                        {
                            !state.twoAuthFactor && (
                                <button
                                    type="button"
                                    onClick={handleRedirectToWebsite}
                                    className={`login-sign-in-btn text-center w-full p-[0.7rem] border rounded-full login-btn-text`}
                                >
                                    Sign up
                                </button>
                            )
                        }

                    </form>
                </div>
                <img className='w-full object-cover login-res' src={LogoWs} alt="" />
            </div>
        </>

    )
}